export default {
  name: 'Promo100kBlog',
  data() {
    return {
      observer: null,
      showImageModal: false,
      selectedImage: { src: '', title: '', subtitle: '', bg: '' },
      images: [
        // single image (replace with a real URL or a local asset in public/)
        { src: 'https://www.songhancapital.com/assets/image/blog_7.jpg', bg: 'linear-gradient(135deg,#ff7a7a,#ffb86b)' }
      ],
      // set/update promo period here (ISO YYYY-MM-DD)
      promoStartISO: '2025-11-26',
      promoEndISO: '2026-12-31'
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.initializeAnimations();
    document.addEventListener('keydown', this.handleEscapeKey);
    if (this.images && this.images[0]) {
      console.log('images[0].src =', this.images[0].src);
    }
    const pills = this.$el?.querySelectorAll('.promo-pill');
    if (pills) {
      pills.forEach((el, idx) => {
        const key = ['pillFreeJoin','pillInstantReward','pillAttractiveOffer'][idx];
        el.addEventListener('mouseover', () => this.onPillHover(key));
        el.addEventListener('focus', () => this.onPillHover(key));
      });
    }
    this.$nextTick(() => {
      const el = this.$el.querySelector('.promo-event');
      if (el) el.classList.add('is-visible');
    });
  },
  methods: {

    onPillHover(key) {
      // this.$analytics?.track('promo_pill_hover', { pill: key });
      // console.log('Hovered pill', key);
    },

    _parseISO(iso) {
      if (!iso) return null;
      const parts = iso.split('-');
      if (parts.length !== 3) return null;
      return new Date(parts[0], Number(parts[1]) - 1, parts[2]);
    },

    triggerAwardConfetti() {
      // short multi-burst confetti
      const duration = 1500;
      const end = Date.now() + duration;

      (function frame() {
        confetti({
          particleCount: 6,
          angle: 60,
          spread: 55,
          origin: { x: 0 }
        });
        confetti({
          particleCount: 6,
          angle: 120,
          spread: 55,
          origin: { x: 1 }
        });
        if (Date.now() < end) {
          requestAnimationFrame(frame);
        }
      }());
    },

    // example: call this when user wins or clicks
    onAwardReceived() {
      // highlight badge once (optional: replace infinite animation with one-shot)
      const el = this.$el && this.$el.querySelector('.pop-text');
      if (el) {
        el.classList.add('award-flash');
        setTimeout(() => el.classList.remove('award-flash'), 1600);
      }
      // run confetti
      this.triggerAwardConfetti();
    },

    goToContact() {
      if (this.$router) this.$router.push('/contact');
      else window.location.href = '/contact';
    },
    openImageModal(item) {
      if (!item) return;
      this.selectedImage = {
        src: item.src || '',
        title: item.title || '',
        subtitle: item.subtitle || '',
        caption: item.caption || '',
        bg: item.bg || 'linear-gradient(135deg,#667eea,#764ba2)'
      };
      this.showImageModal = true;
      document.body.style.overflow = 'hidden';
    },
    closeImageModal() {
      this.showImageModal = false;
      this.selectedImage = { src: '', title: '', subtitle: '', caption: '', bg: '' };
      document.body.style.overflow = 'auto';
    },
    handleEscapeKey(event) {
      if (event.key === 'Escape' && this.showImageModal) {
        this.closeImageModal();
      }
    },
    initializeAnimations() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
              const delay = Array.from(entry.target.parentNode.children).indexOf(entry.target) * 100;
              setTimeout(() => {
                entry.target.style.transitionDelay = `${delay}ms`;
              }, 0);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
      );

      this.$nextTick(() => {
        const elements = document.querySelectorAll('.animate-on-scroll');
        elements.forEach((el) => this.observer.observe(el));
      });
    }
  },
  beforeUnmount() {
    if (this.observer) this.observer.disconnect();
    document.removeEventListener('keydown', this.handleEscapeKey);
    document.body.style.overflow = 'auto';
  }
};
